module.exports = __webpack_public_path__ + "c49af6b54119a37dc675750fe1c6e878.fbx";